import * as React from 'react'; // Reactライブラリをインポート
import UCCategory from "../molecules/UCCategory"; // UCCategoryコンポーネントをインポート
import { Box, TableContainer } from '@mui/material'; // MUIのBoxとTableContainerをインポート
import { UCItemType } from '../atoms/UCItem'; // UCItemType型をインポート

// UCListType型を定義。カテゴリ名とアイテムの配列を持つ
export type UCListType = {
  category: string,
  items: UCItemType[]
}

// Props型を定義。UCListTypeの配列を持つ
type Props = {
  data: UCListType[]
}

/** user コンテンツ一覧を表示するコンポーネント */
const UCList = (props: Props) => {
  return (
    <Box height={'640px'}> {/* 高さ640pxのBoxコンポーネント */}
        <TableContainer sx={{ maxHeight: '640px' }}> {/* 最大高さ640pxのTableContainer */}
          {props.data.map((d, index) => 
            <UCCategory key={index} data={d}/> // 各データに対してUCCategoryコンポーネントをレンダリング
          )}
        </TableContainer>
    </Box>
  );
}

export default UCList; // UCListコンポーネントをエクスポート